import React from 'react';
import { observer} from "mobx-react";
import { Input, Button, Checkbox, Row, Col, Collapse} from 'antd';
import { translateText, getFirstSide } from "../../stores/objects/I18n"
import { materialTypes } from '../../stores/objects/SearchInput';
import { DatePicker, Divider } from 'antd';
import { RightOutlined, LeftOutlined, DownOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const CheckboxGroup = Checkbox.Group;


const SearchInput = observer(({store, inputRef}) => (
  <div style={{ marginBottom: 16 }}>
    <Input ref={inputRef} 
          aria-label="Search input"
            placeholder={translateText(store, "input search text")}
            onChange={e => store.searchInput.value = e.target.value}
            onPressEnter={e => {store.run();}}/>
    </div>
));

const SearchClearButtons = observer(({store}) => (
  <Row type="flex" style={{ marginBottom: 16 }}>
    <Col span={12} order={1}>
    {store.state.searchExists ? 
      (<Button onClick={store.clearSearch} 
               style={{ width: "100%" }}>
        {translateText(store, "Clear search")}
      </Button>) :
      (<Button disabled style={{ width: "100%" }}>
        {translateText(store, "Clear search")}
      </Button>)}
    </Col>
    <Col span={12} order={2}>
    <Button type="primary" 
            onClick={store.run} 
            style={{ width: "100%" }}>
      {translateText(store, "Search")}
    </Button>
    </Col>
  </Row>
  ));

const TranslateCheckbox = observer(({store}) =>
  store.state.language === 'en' ? "" :
    (<div style={{ marginRight: 16 }}>
    <Checkbox onChange={(checked) => {store.searchInput.doTranslate = checked;}}
              defaultChecked={true}
              >
      {translateText(store, "Translate input to English")}
      </Checkbox>
    </div>
  )
);
const TypesCheckbox = observer(({store}) => {
  
  var options=materialTypes.map(s => translateText(store, s));
  return (
  
            <CheckboxGroup style={{ width: '100%' }}
              onChange = {l => store.searchInput.setSelectedTypes(l, options)}>
              {options.map(x => 
                (<Row key={x}>
                  <Checkbox value={x} >{x}</Checkbox>
                </Row>))}
            </CheckboxGroup>
        )
}

);

const DateFilter = observer(({store}) => 
(
  <RangePicker picker="year" onChange={(dates, dateString) => (store.searchInput.dates = dateString)}/>
 
));

const FiltersMenu = observer(({store}) =>
(
  <Collapse 
          ghost expandIconPosition={getFirstSide(store)}
            expandIcon={({ isActive }) => 
          (!isActive ? (getFirstSide(store) === 'rtl' ? 
                          <RightOutlined style={{color : "white"}}/> : <LeftOutlined style={{color : "white"}}/>) 
                          : <DownOutlined style={{color : "white"}}/>)}>
  
  <Panel header={(<span style={{color : "white"}}>{translateText(store, "Filters")}</span>)} key="1">
  <Collapse 
          ghost expandIconPosition={getFirstSide(store)}
            expandIcon={({ isActive }) => 
          (!isActive ? (getFirstSide(store) === 'rtl' ? 
                          <RightOutlined style={{color : "white"}}/> : <LeftOutlined style={{color : "white"}}/>) 
                          : <DownOutlined style={{color : "white"}}/>)}>
    <Panel header={(<span style={{color : "white"}}>{translateText(store, "Material type")}</span>)} key="Material_type" style={{lineHeight : 'normal'}}>
    <TypesCheckbox store={store}/>
    </Panel >
    <Panel header={(<span style={{color : "white"}}>{translateText(store, "Date")}</span>)} key="date">
    <DateFilter store={store}/>
    </Panel>
    </Collapse>
    </Panel>
    </Collapse>
));

const SearchPanel = observer(({store, inputRef}) => ( 
    <div>
    <SearchInput store={store} inputRef={inputRef}/>
    <TranslateCheckbox store={store} />
    <FiltersMenu store={store} />
    <Divider/>
    <SearchClearButtons store={store}/>

    </div>
  )
);

export default SearchPanel;